module.exports = __webpack_public_path__ + "media/application/images/icons/peoples-choice-761656be976707f491e90213b5bc62ac.svg";